import React, { useEffect, useState } from 'react';
import './becoming-a-participant.scss';

// Assets
// ---------------------
import Gir from '../../assets/images/gir.png';
import Gmd from '../../assets/images/gmd.png';

// Components
// ---------------------
import { Clickbox } from '../../components/clickbox/clickbox';
import { LoadingSpinner } from '../../components/loading-spinner/loading-spinner';

// API
// ---------------------
import { cmsDocumentList } from '../../api/api';

export const BecomingAParticipant = ({ ...props }) => {
  const [documents, setDocuments] = useState([]);
  const [forms, setForms] = useState([]);

  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    // Gets Documentation
    cmsDocumentList({}, { CmsComponent: 'Documentation' })
      .then((response) => {
        const documents = response.data.documents.map((document) => {
          const params = `cmsId=${document.cmsId}&fileName=${document.meta.title}&componentType=RAW`;
          return {
            item: document.meta.title,
            path: `/sigmaxmtf/downloadDocuments?downloadType=cms&${params}`,
            isDownload: false,
            newTab: true,
          };
        });
        setDocuments(documents);

        // Get Forms
        cmsDocumentList({}, { CmsComponent: 'Forms' })
          .then((response) => {
            const forms = response.data.documents.map((document) => {
              const params = `cmsId=${document.cmsId}&fileName=${document.meta.title}&componentType=RAW`;
              return {
                item: document.meta.title,
                path: `/sigmaxmtf/downloadDocuments?downloadType=cms&${params}`,
                isDownload: false,
                newTab: true,
              };
            });
            setForms(forms);
            setIsLoading(false);
          })
          .catch((error) => {
            console.error(error);
          });
      })
      .catch((error) => {
        console.error(error);
      });
  }, []);

  return (
    <div className={`becoming-a-participant-page`}>
      <div className="page-text">
        <div className="connection-callout">
          <span>
            Want to get connected? Details and required documentation are below
          </span>
        </div>
        <div className="delivery-instructions">
          <span>
            Please complete and return the following documentation to{' '}
          </span>
          <a
            className="mail-to"
            href="mailto:GSSIGMAXMTF@gs.com"
            aria-label="Mail to GSSIGMAXMTF@gs.com"
          >
            GSSIGMAXMTF@gs.com
          </a>
        </div>
      </div>
      <div className="gs-document-list">
        <LoadingSpinner
          status={isLoading}
          name={'Goldman Sachs Sigma X MTF Documents'}
        />
        <div className="gs-documents">
          {documents.map((item, i) => {
            return (
              <Clickbox
                key={i}
                text={item.item}
                path={item.path}
                isDownload={item.isDownload ? item.isDownload : false}
                newTab={item.newTab ? item.newTab : false}
              />
            );
          })}
        </div>
      </div>
      <div className="page-text">
        <span className="delivery-instructions">
          Please complete and return the following documentation to Irish
          Revenue Commissioners
        </span>
      </div>
      <div className="irc-document-list">
        <LoadingSpinner
          status={isLoading}
          name={'Irish Revenue Commissioners Documents'}
        />
        <div className="irc-documents">
          {forms.map((item, i) => {
            return (
              <Clickbox
                key={i}
                text={item.item}
                path={item.path}
                isDownload={item.isDownload ? item.isDownload : false}
                newTab={item.newTab ? item.newTab : false}
              />
            );
          })}

          <div className="display-images">
            <div>
              <img
                src={Gmd}
                alt="Depiction of a network of connected persons"
              />
            </div>
            <div>
              <img
                src={Gir}
                alt="A person analyzing information on multiple computer monitors"
              />
            </div>
          </div>
        </div>
        {/* <div className="flex-spacer"></div> */}
      </div>
    </div>
  );
};
